import { NAME as APP_NAME } from 'constants';
import moment from 'moment';

const now = moment();
const startToday = now.startOf('day').toISOString();
const endToday = now.endOf('day').toISOString();

export const NAME = `${APP_NAME}/TAP`;

export const ROUTES = {
  root: '/tap',
};

export const REDUCER_NAME = 'TAP';

export const TRACKING_REDUCER_NAME = 'TAP_TRACKING';

export const TRACKING_PATH_REDUCER_NAME = 'TAP_PATH_TRACKING';

export const LISTING_ENDPOINT = `${REPORTING_EDGE}/api/v2/reports/trips`;

export const LISTING_TRACKING_ENDPOINT = `${REPORTING_EDGE}/api/v2/reports/drivers-active-trips`;

export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiYXNlZGVyIiwiYSI6ImNrNW5xZzFydTB5em4zanFwdWNwMmNxYWwifQ.EIqF8slrBWZSCpkL4GZczA';

export const REFRESH_INTERVAL = 1000 * 60 * 5;

export const MESSAGES_PREFIXES = ['DROPOFF:', 'WHATSAPP:'];

export const STRATEGY_TYPES = ['LTL', 'TL'];
